@if (showAccessRequestBanner()) {
	<prism-banner
		show-close="false"
		id="sh-elevated-access-request-banner"
		*transloco="let t; read: 'cloud.shared.elevated-access'"
	>
		<prism-icon slot="icon" icon="warning_amber"></prism-icon>
		@switch (elevatedRequestDetails()?.requestStatus?.toLowerCase()) {
			@case (elevatedRequestStatus.Pending) {
				<span id="sh-elevated-access-request-span">{{ t('access-request-info') }}</span>
				<div id="sh-elevated-access-action-buttons-div">
					<prism-button
						class="prism-button"
						id="header-toolbar-feature-request-button"
						variant="standard"
						size="md"
						(click)="approveElevatedRequest()"
					>
						{{ t('accept') }}
					</prism-button>
					<prism-button
						class="prism-button"
						id="header-toolbar-feature-request-button"
						variant="standard"
						size="md"
						(click)="rejectElevatedRequest()"
					>
						{{ t('reject') }}
					</prism-button>
				</div>
			}
			@case (elevatedRequestStatus.Granted) {
				@if (formattedElevatedDetails() && !formattedElevatedDetails()!.isExpired) {
					@if (elevatedRequestDetails()?.isElevatedUser) {
						<span id="sh-elevated-access-request-span">{{
							t('stop-accessing-description', {
								dateTime: formattedElevatedDetails()!.expiresAt
							})
						}}</span>
						<div id="sh-elevated-access-action-buttons-div">
							<prism-button
								class="prism-button"
								id="header-toolbar-feature-request-button"
								variant="standard"
								size="md"
								(click)="stopGrantedAccess()"
							>
								{{ t('stop-accessing') }}
							</prism-button>
						</div>
					} @else {
						<span id="sh-elevated-grant-stop-access-span">
							{{
								t('grant-revoke-access-info', {
									dateTime: formattedElevatedDetails()!.expiresAt
								})
							}}</span
						>

						<div id="sh-elevated-access-action-buttons-div">
							<prism-button
								class="prism-button"
								id="sh-elevated-access-feature-extend-access-button"
								variant="standard"
								size="md"
								(click)="openExtendAccessDialog()"
							>
								{{ t('extend-access') }}
							</prism-button>

							<prism-button
								class="prism-button"
								id="sh-elevated-access-feature-revoke-access-button"
								variant="danger"
								size="md"
								(click)="stopAccess()"
							>
								{{ t('revoke-access') }}
							</prism-button>
						</div>
					}
				}
			}
		}
	</prism-banner>
}
